import { useHistory } from 'react-router-dom';
import { useMutation } from 'react-query';
import { makeRequest } from '@crx-dev/hss-react-infrastructure';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { Heading, Form, getFieldProps, LookupFieldOption, Page } from '@crx-dev/hss-react-components';
import ProductLookup from '../../../Common/ProductLookup/ProductLookup';
import React, { useCallback } from 'react';
import { ReturnedRegisterSummary } from '../types/ReturnedRegisterSummary';
import { CreateReturnedRegisterRequest } from '../types/CreateReturnedRegisterRequest';

interface FormValues {
    selectedProduct: null | LookupFieldOption;
}

function CreateReturnedRegisterForm() {
    const history = useHistory();

    const mutation = useMutation<ReturnedRegisterSummary, unknown, CreateReturnedRegisterRequest>(item =>
        makeRequest({
            method: 'POST',
            path: '/api/V1/ReturnedDrugRegister',
            data: item
        })
    );

    const formik = useFormik<FormValues>({
        initialValues: {
            selectedProduct: null
        },
        validationSchema: yup.object().shape({
            selectedProduct: yup
                .object()
                .nullable()
                .required('Required')
        }),
        onSubmit: async values => {
            const resipId = (values.selectedProduct as LookupFieldOption).value;
            const registerSummary = await mutation.mutateAsync({
                resipId
            });
            history.push(`/returned-registers/${registerSummary.id}`);
        }
    });

    const handleCreateDrugClick = useCallback(() => {
        history.push('/returned-registers/addManual');
    }, []);

    return (
        <Page>
            <Page.Header title="Add New Returned Register" onBackClick={() => history.push('/returned-registers')} />
            <Page.Content>
                <Form onSubmit={formik.handleSubmit}>
                    <Form.Section>
                        <Heading>Drug Details</Heading>
                        <ProductLookup {...getFieldProps(formik, 'selectedProduct')} marginTop={0} />
                    </Form.Section>
                    <Form.Footer
                        onCancel={handleCreateDrugClick}
                        isSubmitting={mutation.isLoading}
                        submitError={mutation.isError}
                        submitButtonLabel="OK"
                        cancelButtonLabel="CREATE DRUG"
                    />
                </Form>
            </Page.Content>
        </Page>
    );
}

export default CreateReturnedRegisterForm;
